import { centsToDollars, isset } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class BookNowBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.setDockType = this.setDockType.bind(this)
    this.hasPrice = this.hasPrice.bind(this)
    this.textStyle = this.textStyle.bind(this)
    this.buttonText = this.buttonText.bind(this)
    this.needsVerticalData = this.needsVerticalData.bind(this)
    this.moneyText = this.moneyText.bind(this)
  }

  setDockType() {
    if (this.hasPrice()) {
      Amplitude.trackEvent("reservation_flow:continue_to_reserve_pressed", {
        marina_id: this.props.marina.mcomId,
        marina_name: this.props.marina.name,
        experience_name: "reservation_flow",
        embed_form: !!this.props.embedForm,
      })
    }
    if (this.hasPrice() && !this.needsVerticalData()) {
      this.props.setGlobalState({ dockType: this.props.name })
      this.props.routeTo("next")
    } else {
      this.props.setGlobalState({ estimateBtnPressed: true })
    }
  }

  hasPrice() {
    return isset(this.props.price) === true && this.props.price !== false
  }

  textStyle() {
    if (this.hasPrice()) {
      return {}
    } else if (
      this.props.state.estimateBtnPressed === true &&
      this.props.state.initialPriceEstimate === false
    ) {
      return { color: "#a94442", fontSize: "14px" }
    } else {
      return { fontSize: "16px" }
    }
  }

  buttonText() {
    if (this.hasPrice()) {
      return "Continue to Reserve"
    } else {
      return "Request Reservation"
    }
  }

  needsVerticalData() {
    const {
      boatCreated,
      draftMissing,
      heightMissing,
      height: boatHeight,
      draft: boatDraw,
    } = this.props.state
    const needVerticalData =
      boatCreated !== "previously" || draftMissing || heightMissing
    return needVerticalData && !(boatHeight || boatDraw)
  }

  moneyText() {
    if (this.needsVerticalData()) {
      return "Enter a length overall, height, draft, arrival, and departure to view price."
    } else if (this.hasPrice()) {
      return centsToDollars(this.props.price)
    } else if (
      this.props.state.estimateBtnPressed === true &&
      this.props.state.initialPriceEstimate === false
    ) {
      return "Enter length overall, arrival, and departure to view price."
    } else {
      return "Select dates to view price."
    }
  }

  renderMinNightRequirement() {
    if (this.props.state.minNightRequirement) {
      const minNightReqText = `The date(s) selected reflect a ${this.props.state.minNightRequirement}-night minimum rate. You may book for less than ${this.props.state.minNightRequirement} nights, but you will be charged for the minimum nights.`
      return (
        <div className="mb-6 w-full rounded bg-blue-100 px-5 py-3 text-center text-xs">
          {minNightReqText}
        </div>
      )
    }
  }

  render() {
    return (
      <div id="bookNowBox" className="book-now-box">
        <div id="bookNowBoxTitle" className="title text-center">
          {this.props.name}
          <i
            className="icon icon-question-circle cursor-pointer"
            style={{
              position: "absolute",
              fontSize: ".7em",
              padding: "5px 8px",
              color: "#D1DBE1",
            }}
            data-container="body"
            data-toggle="popover"
            data-placement="top"
            data-content="This price is only an estimate. The final price breakdown, including discounts, will be displayed on the checkout screen."
          />
        </div>
        <div
          id="priceEstimateMessag"
          className="price text-center"
          style={this.textStyle()}
        >
          {this.moneyText()}
        </div>
        {this.props.state.dockwaBalanceAmount > 0 && (
          <div
            id="dockwaDollarsCreditMessage"
            className="text-muted mb-2.5 text-center"
          >
            You have{" "}
            <strong>
              {centsToDollars(this.props.state.dockwaBalanceAmount)}
            </strong>{" "}
            of Dockwa Dollar credit applied towards this transaction.
          </div>
        )}
        {this.renderMinNightRequirement()}
        <button
          id="bookNowBoxContinueButton"
          type="button"
          className="btn btn-primary center-block"
          onClick={this.setDockType}
          disabled={this.props.state.nextDisabled}
        >
          {this.buttonText()}
        </button>
      </div>
    )
  }
}

BookNowBox.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.number,
  marina: PropTypes.shape({
    mcomId: PropTypes.string,
    name: PropTypes.string,
  }),
  state: PropTypes.shape({
    estimateBtnPressed: PropTypes.bool,
    initialPriceEstimate: PropTypes.bool,
    boatCreated: PropTypes.string,
    draftMissing: PropTypes.bool,
    heightMissing: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    draft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dockwaBalanceAmount: PropTypes.number,
    minNightRequirement: PropTypes.number,
    nextDisabled: PropTypes.bool,
    dockType: PropTypes.string,
  }),
  setGlobalState: PropTypes.func.isRequired,
  routeTo: PropTypes.func.isRequired,
  embedForm: PropTypes.bool,
}

export default BookNowBox
